import { cn } from "@/lib/utils";

export interface FilterChipOption<T extends string = string> {
  id: T;
  label: string;
}

export interface FilterChipBarProps<T extends string = string> {
  options: ReadonlyArray<FilterChipOption<T>>;
  value: T;
  onChange: (next: T) => void;
  className?: string;
  "aria-label"?: string;
}

export function FilterChipBar<T extends string = string>({
  options,
  value,
  onChange,
  className,
  "aria-label": ariaLabel = "Filter",
}: FilterChipBarProps<T>) {
  return (
    <div role="tablist" aria-label={ariaLabel} className={cn("inline-flex flex-nowrap items-center gap-1.5", className)}>
      {options.map((opt) => {
        const selected = opt.id === value;
        return (
          <button
            key={opt.id}
            role="tab"
            type="button"
            aria-selected={selected}
            onClick={() => onChange(opt.id)}
            className={cn(
              "inline-flex items-center rounded-md px-4 py-1.5 text-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
              selected
                ? "bg-[#0f3453] text-white font-medium border-transparent shadow-sm"
                : "bg-info/15 text-primary hover:bg-info/25 border-transparent",
            )}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
